module.exports = __webpack_public_path__ + "static/media/form-left.019d7f85.png";